import { isPropNotEmpty } from "../object";

export default function getRequirementsGroup(parent, level) {
  const requirementsGroup = [];
  const parentRef = [level, parent];
  requirementsGroup.push(parentRef);
  if (isPropNotEmpty(parent, "requirements")) {
    parent.requirements.forEach((item) => {
      if (item.requirements) {
        requirementsGroup.push(...getRequirementsGroup(item, level + 1));
      } else {
        requirementsGroup.push([level + 1, item]);
      }
    });
  }
  return requirementsGroup;
}
